module.exports = __webpack_public_path__ + "images/no_invitations.6ccdbd2ba0ec37089aca8f7b652865f6.png";